import { key_exists } from './key_exists'

export const insert_recursive = (obj: any, path: any, value: any) => {
    const path_array = path.split('.')
    path_array.forEach((element: any, index: number) => {
        if (key_exists(obj, element)) {
            //no changes
        }
        if (!key_exists(obj, element) && index !== path_array.length - 1) {
            obj[element] = {}
        }

        if (index === path_array.length - 1) {
            obj[element] = value
        }
        obj = obj[element]
    })
}
